export const groupListModalConstants = {
    OPEN_GROUP_LIST_MODAL: 'OPEN_GROUP_LIST_MODAL',
    CLOSE_GROUP_LIST_MODAL: 'CLOSE_GROUP_LIST_MODAL'
};